module.exports = __webpack_public_path__ + "img/76_22.6c4ff08f.png";